/**
 * https://ionicframework.com/docs/react/slides
 */

import SwiperCore, {Autoplay, Pagination} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IonicSwiper } from '@ionic/react';
import React from "react";
import { IonCol, IonRow } from '@ionic/react';

import 'swiper/swiper-bundle.min.css';
import '@ionic/react/css/ionic-swiper.css';

import DRHS from "../../assets/img/partners/DRHS.png";
import IEA from "../../assets/img/partners/IEA.png";
import IHSA from "../../assets/img/partners/IHSA.png";
import MHAPS from "../../assets/img/partners/MHAPS.png";
import NEE from "../../assets/img/partners/NEE.png";
import NRBC from "../../assets/img/partners/NRBC.png";
import OET from "../../assets/img/partners/OET.png";
import PonyFinals from "../../assets/img/partners/PonyFinals.png";
import PRHP from "../../assets/img/partners/PRHP.png";
import RMF from "../../assets/img/partners/RMF.png";
import USHJA from "../../assets/img/partners/USHJA.png";

SwiperCore.use([Autoplay, IonicSwiper, Pagination]);

export interface PartnerSlide {
    title: string
    description: string
    image: string
}


const partners: PartnerSlide[] = [
    {
        title: "USEF Pony Finals",
        description: "Championship",
        image: PonyFinals
    },
    {
        title: "Nilforushan Equisport Events",
        description: "Horse Show Management",
        image: NEE
    },
    {
        title: "Paso Robles Horse Park",
        description: "Horse Show Series",
        image: PRHP
    },
    {
        title: "IEA",
        description: "National Finals",
        image: IEA
    },
    {
        title: "IHSA",
        description: "National Finals",
        image: IHSA
    },
    {
        title: "National Reining Breeders Classic",
        description: "Horse Show",
        image: NRBC
    },
    {
        title: "Ottawa Equestrian Tournament",
        description: "Horse Show Series",
        image: OET
    },
    {
        title: "Maryland Horse and Pony Show",
        description: "Horse Show",
        image: MHAPS
    },
    {
        title: "Deep Run Horse Show",
        description: "Horse Show",
        image: DRHS
    },
    {
        title: "Rose Mount Farm Horse Show",
        description: "Horse Show",
        image: RMF
    },
    {
        title: "USHJA Las Vegas",
        description: "Championship",
        image: USHJA
    }
];

const PartnersCarousel: React.FC = () => {
    return (
        <IonRow className="ion-align-items-stretch">
            {partners ? 
                <Swiper 
                    slidesPerView={4} 
                    spaceBetween={30} 
                    breakpoints={{
                        // when window width is >= 320px
                        1: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        }
                    }}
                    centeredSlides={true}
                    loop={true}
                    autoplay={true}
                    pagination={{"clickable": true}} 
                    className="mySwiper"
                >
                    {partners.map((item, index) => (
                        <SwiperSlide key={index} className="rsp-swiper-slide">
                            <div className="mb-4">
                                <IonRow className="justify-content-center">
                                    <IonCol size="6" className="text-center">
                                        <img className="shadow bg-white img" alt="testimonial" src={item.image}/>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol className="ion-text-center">
                                        <h4>{item.title}</h4>
                                        <p className="description">{item.description}</p>
                                    </IonCol>
                                </IonRow>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                :
                <p>Loading...</p>
            }
            
        </IonRow>
    );
};

export default PartnersCarousel;
